import React, {Component} from 'react';
import {Link, NavLink} from "react-router-dom";

class SideNav extends Component {
    render() {
        return (

            <nav className="sidebar">
                <div className="sidebar-header">


                    <a href="#" className="sidebar-brand"> <span>     <img src="assets/img/logo.png" className="logo_mini" alt={'MAKN MAAL'}/>Maal Portal</span> </a>
                    <div className="sidebar-toggler not-active">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="sidebar-body">
                    <ul className="nav">
                        <li className="nav-item nav-category">Main</li>
                        <li className={window.location.pathname === "/dashboard" ? "nav-item active" : "nav-item"} >
                            <NavLink to="/dashboard" className="nav-link" activeClassName="active">
                                <i className="link-icon" data-feather="home"></i>
                                <span className="link-title">Dashboard</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/pay" className="nav-link"  activeClassName="active">
                                <i className="link-icon" data-feather="credit-card"></i>
                                <span className="link-title">Make Payment</span>
                            </NavLink>
                        </li>

                        <li className={window.location.pathname === "/history" ? "nav-item active" : "nav-item"}>
                            <NavLink to={'/history'} className="nav-link" activeClassName="active">
                                <i className="link-icon " data-feather="clock"></i>
                                <span className="link-title">History</span>
                            </NavLink>
                        </li>


                        <li className="nav-item nav-category">More</li>
                        <li className="nav-item">
                            <NavLink to="/chanda-calculator" className="nav-link" activeClassName="active">
                                <i className="link-icon" data-feather="hash"></i>
                                <span className="link-title">Chanda Calculator</span>
                            </NavLink>
                        </li>


                    </ul>
                </div>
            </nav>

        )

    }
}

export default SideNav;
